/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
import { classNames } from 'shared/lib/classNames/classNames';
import React, { useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import CardPlug from 'shared/assets/img/pages/card-plug.png';
import { useApi } from 'app/api/APIProvider';
import cls from './TransactionClosedCard.module.scss';
import { formatNumber } from 'shared/lib/utils/utils';

interface TransactionProps {
    transaction: any,
    showPercentage: boolean,
    detail?: boolean,
}

export const TransactionClosedCard = ({ transaction, showPercentage = true }: TransactionProps) => {
    const api = useApi();
    const {
        name,
        earnedAll,
        earnedPercent,
        refillPerYear,
        percentageRate,
        initialMoney,
        level,
        contributionAmount,
        term,
        savedSum,
        sum,
    } = transaction;

    const levelText: any = {
        1: 'Закрытый вклад первого уровня',
        2: 'Закрытый вклад второго уровня',
        3: 'Закрытый вклад третьего уровня',
        4: 'Закрытый вклад четвертого уровня',
    };

    // const {
    //     name,
    //     depositAmount,
    //     refillPerYear,
    //     percentageRate,
    //     term,
    //     сontributionAmount,
    //     savedPercentages,
    //     totalSum,
    // } = transaction;


    return (
        <div className={cls.card}>
            <div className={cls.detailContent}>
                <div className={cls.contentFlexElem}>
                    <Title className={cls.mainName} color="#353850" size={TitleSize.title_20}>{name ? name : levelText[level]}</Title>
                    {initialMoney && <div className={cls.contentElem}>
                        <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Сумма вклада</Text>
                        <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>{formatNumber(Number(initialMoney))} ₽</Text>
                    </div>}
                    {(initialMoney || refillPerYear) && <div className={cls.contentElem}>
                        <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Сумма пополнения в год</Text>
                        <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>{formatNumber(Number(refillPerYear)) ?? formatNumber(Number(initialMoney))} ₽</Text>
                    </div>}
                    {
                        (showPercentage && !percentageRate) && <div className={cls.contentElem}>
                            <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Процентная ставка</Text>
                            <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>8 %</Text>
                        </div>
                    }
                    {
                        percentageRate && <div className={cls.contentElem}>
                            <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Процентная ставка</Text>
                            <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>{percentageRate}</Text>
                        </div>
                    }
                    {contributionAmount && <div className={cls.contentElem}>
                        <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Сумма взноса</Text>
                        <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>{formatNumber(Number(contributionAmount))} ₽</Text>
                    </div>}
                    {sum && <div className={cls.contentElem}>
                        <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Сумма кредита</Text>
                        <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>{formatNumber(Number(sum))} ₽</Text>
                    </div>}
                    {term && <div className={cls.contentElem}>
                        <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Срок</Text>
                        <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>{term}</Text>
                    </div>}
                    {/* {earnedPercent && <div className={cls.contentElem}>
                        <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Накопленные проценты</Text>
                        <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>{formatNumber(Number(earnedPercent))} ₽</Text>
                    </div>} */}
                    {savedSum && <div className={cls.contentElem}>
                        <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Накоплено</Text>
                        <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>{formatNumber(Number(savedSum))} ₽</Text>
                    </div>}
                    {
                       earnedAll && <div className={cls.contentElem}>
                        <Text className={cls.name} color="#7B7B7B" size={TextSize.text_16}>Итого</Text>
                        <Text className={cls.title} color="#353850" size={TextSize.text_16_600}>{formatNumber(Number(earnedAll))} ₽</Text>
                    </div>
                    }
                </div>
            </div>
        </div>
    );
};

